export default function Terms1() {
    return (
        <>
            <p>【서비스 이용약관】</p>
            <p>제 1 장 총칙</p>
            <p>제1조 (목적)</p>
            <p>본 약관은 (주)코엑스와 (주)지에스아이엘(이하 “회사”)이 공동개발하여 제공하는「전시장 맞춤 통합안전플랫폼」(S100 MICE)(이하 “서비스”)를 이용함에 있어 회사와와 회원간의 권리, 의무 및 책임사항, 기타 필요한 사항 등을 규정함을 목적으로 합니다.</p>
            <p>제2조 (용어의 정의)</p>
            <p>① 본 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>
            <p>1. 서비스 : 회사가 회원에게 제공하는 「전시장 맞춤 통합안전플랫폼」(S100 MICE)의 각 기능 및 이와 관련된 콘텐츠 등의 서비스를 의미합니다.</p>
            <p>2. 행사 : 코엑스가 시행하는 전시사업장에서 진행되는 행사로서 본 서비스가 적용 및 제공되는 지리적, 사업적 구역을 의미합니다.</p>
            <p>3. 회원 : 상기 2호의 행사에 소속된 자로서 본 약관에 따라 서비스 사이트에 가입 후 서비스를 이용하는 자를 의미합니다.</p>
            <p>4. 개인위치정보주체 : 본 약관에서 “개인위치정보주체”라 함은 서비스에 가입한 회원으로서 개인 위치정보에 의하여 식별되는 자를 말하며 통상 회원과 동일한 것으로 간주됩니다.</p>
            <p>5.가입 : 본 서비스 사이트가 제공하는 신청서 서식에 해당 정보를 기입하고, 코엑스 승인 후 본 약관에 동의하여 서비스 이용계약을 완료시키는 행위를 의미합니다.</p>
            <p>6. 아이디(ID) : 회원의 식별과 서비스 이용을 위하여 회원이의 휴대폰번호로 설정한 고유 체계를 의미합니다.</p>
            <p>7. 비밀번호 : 회원의 아이디가 일치하는지를 확인하고 정보통신 상에서 회원 자신의 비밀 보호를 위하여 회원이 정한 문자와 숫자의 조합으로 설정한 고유 체계를 의미합니다.</p>
            <p>8. 탈퇴 : 회원이 이용계약을 종료시키는 행위를 의미합니다.</p>
            <p>② 본 약관에서 사용하는 용어의 정의는 제1항에서 정하는 것을 제외하고는 서비스별 안내에서 정하는 바에 따릅니다.</p>
            <p>제3조 (약관의 효력, 개정 및 해석)</p>
            <p>① 본 약관의 내용은 서비스 사이트에 게시하거나 기타의 방법으로 회원에게 공시하고, 이에 동의한 회원이 서비스에 가입함으로써 효력이 발생합니다.</p>
            <p>② 본 약관은 회사가 필요하다고 판단한 경우 대한민국 법령의 범위 내에서 개정할 수 있습니다. 회사가 약관을 개정할 경우에는 적용 예정일 및 개정사유를 명시하여 현행 약관과 함께 서비스 초기화면에 그 적용예정일 7일 전부터 공지합니다. 다만, 회원에게 불리하게 약관 내용을 변경할 때는 최소한 30일 이상의 사전 유예기간을 두고 공지하는 것 외에 문자 발송 등 전자적 수단을 통해 별도로 통지합니다.</p>
            <p>③ 회원은 개정된 약관에 대해 동의하지 않을 권리가 있으며, 개정된 약관에 동의하지 않을 경우 이용계약을 해지할 수 있습니다. 회원이 회사의 전항 단서에 따른 약관의 불리한 변경에 대하여 적용 예정일까지 회사에게 부동의 의사를 표시하지 않거나 이용계약을 해지하지 않으면 변경된 약관을 승인한 것으로 봅니다.</p>
            <p>④ 회사는 필요한 경우 이 서비스 외에 개별 서비스 및 서비스 정책에 대하여 별도의 이용약관 및 정책을 둘 수 있습니다. 이때, 해당 내용이 본 약관과 상충하면 별도의 이용약관 및 서비스 정책이 우선하여 적용됩니다.</p>
            <p>제 2 장 서비스 이용계약 및 회원관리</p>
            <p>제4조 (이용계약의 성립, 이용신청 및 승낙)</p>
            <p>① 이용계약은 서비스를 이용하고자 하는 자가 본 약관에 동의하고 제출한 이용신청(회원가입신청)에 대하여 코엑스가 승인함으로써 체결됩니다.</p>
            <p>② 코엑스는 다음의 각호에 해당하는 신청에 대하여는 승인을 거절할 수 있으며, 이 사유가 해소될 때까지 승인을 유보하거나 승인한 이후에도 이용계약을 해지할 수 있습니다.</p>
            <p>1. 기술상 서비스 제공이 불가능하거나 서비스 관련 설비 용량이 부족한 경우</p>
            <p>2. 실명이 아니거나, 다른 사람의 명의 사용 등 회원 등록 시 허위로 신청하는 경우</p>
            <p>3. 회원 등록 사항을 누락하거나 오기하여 신청하는 경우</p>
            <p>4. 19세 미만 미성년자가 법정대리인(부모 등)의 동의를 얻지 아니한 경우</p>
            <p>5. 사회의 안녕질서 또는 미풍양속을 저해하거나, 저해할 목적으로 신청한 경우</p>
            <p>6. 회원이 본 서비스를 그 이용목적에 반하여 이용하거나 이용행위가 법령에 위반되어 제3자의 권리를 침해할 우려가 있는 경우</p>
            <p>7. 악성 프로그램 및 버그 이용 또는 시스템 취약점을 악용하는 등 부정한 방법을 서비스에 사용한 경우</p>
            <p>8. 이번 가입 신청 이전에 본 조 2항의 각호를 위반하여 회원 자격을 상실한 적이 있는 경우</p>
            <p>9. 기타 코엑스가 정한 이용 신청 요건이 충족되지 않았을 경우</p>
            <p>제5조 (회원정보의 변경)</p>
            <p>① 회원은 회원정보 관리화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다. 다만, 아이디 등 서비스 운영을 위하여 회사가 정한 일부 사항은 수정이 제한될 수 있습니다.</p>
            <p>② 회원은 이용 신청 시 기재한 사항이 변경되었을 경우, 즉시 온라인으로 수정을 하거나 회사가 정한 별도의 정해진 서식 및 이용 방법으로 변경사항을 알려야 하며 변경사항을 알리지 아니하여 발생한 불이익에 대하여 회사는 책임지지 않습니다.</p>
            <p>제 3 장 서비스 이용에 관한 일반사항</p>
            <p>제6조 (서비스의 이용개시)</p>
            <p>① 본 서비스는 회원의 이용신청에 대하여 코엑스가 승인한 때부터 이용이 개시됩니다. 단, 일부 서비스의 경우에는 지정된 일시부터 서비스를 개시합니다.</p>
            <p>② 회사는 업무상 또는 기술상의 장애로 인하여 서비스를 즉시 개시하지 못할 경우에는 홈페이지에 공시하거나 회원에 이를 통지합니다.</p>
            <p>③ 회사는 특정한 서비스를 제공하기 위해 회원에게 별도 또는 추가적인 가입절차를 요청할 수 있으며, 이러한 특정 서비스를 이용할 경우 해당 사이트 또는 서비스에 대한 이용약관, 규정 또는 세칙 등이 본 약관보다 우선 적용됩니다.</p>
            <p>제7조 (서비스의 이용시간)</p>
            <p>① 서비스의 이용은 회사의 업무상 또는 기술상의 특별한 지장이 없는 한 연중무휴, 1일 24시간을 원칙으로 합니다.</p>
            <p>② 제1항의 이용 시간은 정기 점검 등의 필요로 인하여 당 사이트가 정한 날 또는 시간은 예외로 합니다.</p>
            <p>제8조 (서비스의 변경 및 중지 등)</p>
            <p>① 회사는 수시로 서비스의 향상을 위하여 기존 서비스의 전부 또는 일부를 추가, 변경할 수 있습니다. 이 경우 회사는 추가, 변경될 서비스의 내용 및 제공 일자를 본 약관 제11조에서 정한 방법으로 회원에게 통지합니다.</p>
            <p>② 회사는 다음 각 호에 해당하는 경우 서비스의 전부 또는 일부를 제한하거나 중지할 수 있습니다.</p>
            <p>1. 컴퓨터 등 정보통신 설비의 보수 점검 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우</p>
            <p>2. 서비스를 위한 설비의 보수 등 공사로 인해 부득이한 경우</p>
            <p>3. 서비스 업그레이드 및 사이트 유지보수 등을 위해 필요한 경우</p>
            <p>4. 정전, 제반 설비의 장애 또는 이용량의 폭주 등으로 정상적인 서비스 이용에 지장이 있는 경우</p>
            <p>5. 회원이 회사의 영업활동을 방해하는 경우</p>
            <p>6. 서비스 위탁운영자와의 계약 종료 등 회사의 제반 사정으로 서비스를 유지할 수 없는 경우</p>
            <p>7. 기타 천재지변, 국가비상사태 등 불가항력적 사유가 있는 경우</p>
            <p>③ 본 조 제2항에 의한 서비스 중단의 경우에는 본 약관 제11조에서 정한 방법으로 회원에게 통지합니다. 단, 회사가 통제할 수 없는 사유로 인한 서비스의 중단(운영자의 고의나 과실이 없는 디스크 장애, 시스템 장애 등)으로 인하여 사전 통지가 불가능한 경우에는 그러하지 아니합니다.</p>
            <p>④ 회사는 다음 각 호의 어느 하나에 해당하는 사유가 발생하는 경우, 서비스 휴지 또는 폐지 사유 및 휴지 또는 폐지일자 등을 휴지 또는 폐지 전에 SMS 또는 E-mail을 통해 회원에게 개별 통지함으로써 서비스를 휴지 또는 폐지할 수 있습니다. 단, 제1호의 경우 휴지 또는 폐지 30일 전에 개별 통지하는 것을 원칙으로 합니다. 회원의 연락처 미기재, 변경 등으로 인하여 상기 개별 통지가 어려운 경우에는 당 사이트에 게시함으로써 개별 통지에 갈음할 수 있습니다.</p>
            <p>1. 사업환경의 변화 또는 기술 발전 등으로 인하여 서비스를 계속 제공 하는 것이 현저히 곤란한 경우</p>
            <p>2. 행정기관의 행정처분이나 법원의 판결, 결정 등으로 인하여 서비스를 계속 제공할 수 없는 경우</p>
            <p>3. 전시, 사변, 천재지변 및 기타 불가항력적 사유로 서비스를 제공하는 것이 현저히 곤란한 경우</p>
            <p>제 4 장 계약당사자의 의무</p>
            <p>제9조 (회사의 의무)</p>
            <p>① 회사는 서비스 제공과 관련하여 취득한 회원의 정보를 본인의 승인없이 타인에게 누설 또는 배포할 수 없으며, 상업적 목적으로 사용할 수 없습니다. 다만, 정보통신 관련법령 등 관계법령에 의하여 관계 국가기관 등의 요구가 있는 경우에는 그러하지 아니합니다.</p>
            <p>② 회사는 이용자의 귀책사유로 인한 서비스 이용 장애에 대하여 책임을 지지 않습니다.</p>
            <p>③ 회사는 정보통신망 이용촉진 및 정보보호에 관한 법률, 통신비밀보호법 등 서비스의 운영, 유지와 관련 있는 법규를 준수합니다.</p>
            <p>제10조 (회원의 의무)</p>
            <p>① 회원 가입 시에 요구되는 정보는 사실에 맞게 정확하게 기입하여야 합니다. 또한 이 사이트에 이미 제공된 회원의 정확한 정보가 유지, 갱신되어야 하며, 회원은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는 안됩니다.</p>
            <p>② 회원은 회사의 사전 승인없이 서비스를 이용하여 어떠한 영리행위도 할 수 없습니다.</p>
            <p>③ 회원은 서비스 이용과 관련하여 다음 각 호의 행위를 하여서는 안됩니다.</p>
            <p>1. 다른 회원의 ID를 부정 사용하는 행위</p>
            <p>2. 범죄행위를 목적으로 하거나 기타 범죄행위와 관련된 행위</p>
            <p>3. 선량한 풍속, 기타 사회질서를 해하는 행위</p>
            <p>4. 타인의 명예를 훼손하거나 모욕하는 행위</p>
            <p>5. 타인의 지적재산권 등의 권리를 침해하는 행위</p>
            <p>6. 해킹행위 또는 컴퓨터 바이러스의 유포행위</p>
            <p>7. 타인의 의사에 반하여 광고성 정보 등 일정한 내용을 의도적이거나 지속적으로 전송하는 행위</p>
            <p>8. 서비스의 안정적인 운영에 지장을 주거나 줄 우려가 있는 일체의 행위</p>
            <p>9. 당 사이트에 게시된 정보의 변경</p>
            <p>④ 회원은 이용신청 절차를 수행하고 서비스를 통하여 작업일에 따른 일자별 안전 교육을 이행하여야 합니다.</p>
            <p>제11조 (회원에 대한 통지)</p>
            <p>① 회사는 회원이 회사에 제출한 E-MAIL 주소 또는 SMS 등 기타 통신수단을 이용하여 회원에 대한 통지를 할 수 있습니다. 회원이 E-MAIL 주소 또는 전화번호 등의 정보를 잘못 제출하여 통지가 이루어지지 않는 경우 회사는 회원이 제출한 정보로 발송한 때에 회원에게 도달한 것으로 간주합니다.</p>
            <p>② 회사는 전체 회원 및 불특정 다수 회원에 대한 통지의 경우 회사의 게시판 등에 게시함으로써 개별 통지를 갈음할 수 있습니다.</p>
            <p>제12조 (개인정보의 보호 및 처리 위탁)</p>
            <p>① 회사는 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』, 동법 시행령 및 동법 시행규칙 등 관계 법령이 정하는 바에 따라서 회원 등록정보를 포함한 회원의 개인정보를 보호하기 위하여 노력합니다. 회원의 개인정보보호 및 사용에 대해서는 관계 법령 및 회사의 개인정보 처리방침이 적용됩니다. 단, 회사의 공식 사이트 이외의 웹에서 링크된 사이트에서는 회사의 개인정보 처리방침이 적용되지 않습니다. 또한 회사는 회원의 귀책사유로 인해 유출된 정보에 대해서 일체의 책임을 지지 않습니다.</p>
            <p>② 회사는 수집된 개인정보의 처리 및 관리 등의 업무(이하 업무)를 스스로 수행함을 원칙으로 하나, 필요한 경우 업무의 일부 또는 전부를 회사가 선정한 제3자에게 위탁할 수 있습니다. 회원의 개인정보 처리 등의 위탁에 대해서는 회사의 개인정보 처리방침이 적용됩니다.</p>
            <p>제13조 (양도금지)</p>
            <p>회원은 서비스의 이용권한, 기타 이용 계약상 지위를 타인에게 양도, 증여, 판매, 담보 제공 등의 처분 행위를 할 수 없으며 게시물에 대한 저작권을 포함한 모든 권리 및 책임은 이를 게시한 회원에게 있습니다.</p>
            <p>제 6 장 계약해지 및 이용제한</p>
            <p>제14조 (계약해지)</p>
            <p>① 회원이 서비스 이용계약을 해지하고자 할 경우에는 본인이 사이트 상에서 또는 회사가 정한 별도의 이용 방법으로 회사에 해지 신청을 하여야 합니다.</p>
            <p>② 제21조에서 정한 바에 따라 회원의 자격이 상실된 경우 서비스 이용 계약이 해지된 것으로 간주합니다.</p>
            <p>③ 계약이 해지된 경우, 회원정보, 회원의 서비스 이용기록 및 회원이 생성한 데이터 등의 정보는 행사 준공 후 3년간 보관 뒤 자동 삭제됩니다.</p>
            <p>제15조 (회원자격 제한 및 자격상실)</p>
            <p>① 회사는 회원이 본 약관 제4조 2항 및 제10조에서 정한 의무를 이행하지 않은 경우, 회원에게 제재하여 의무에 대한 시행을 요구할 수 있습니다. 또한 회원자격을 제한 또는 정지시킬 수 있습니다. 이때 회원은 회사에게 제한 또는 정지에 따른 보상을 청구할 수 없습니다. 해당 회원의 경우 코엑스 행사장 내에 작업을 목적으로 하는 입장에 제한이 있을 수 있으며 다른 업무 수행에 불이익이 있을 수 있습니다.</p>
            <p>② 회사는 본 조 제1항에 의해 회원 자격이 제한·정지된 이후 동일한 행위가 2회 이상 반복되거나 30일 이내에 그 사유가 시정되지 아니한 회원에 대하여 회원의 자격을 상실시킬 수 있습니다. 이때 회원은 회사에게 자격 상실에 따른 보상을 청구할 수 없습니다.</p>
            <p>③ 본 조에 따라 회원의 자격을 제한·정지하거나 상실시키는 경우, 회사는 회원에게 전항의 회원자격의 제한, 정지 또는 상실 사실을 제11조(회원에 대한 통지)에 따라 통보합니다.</p>
            <p>④ 회원은 본 조의 조치에 대하여 회사가 정한 절차에 따라 이의신청을 할 수 있으며, 회원의 이의가 정당하다고 회사가 인정하는 경우 회사는 즉시 서비스의 이용을 재개합니다.</p>
            <p>제 8 장 개인위치정보 수집 및 이용</p>
            <p>제16조 (개인위치정보주체의 권리)</p>
            <p>① 개인위치정보주체는 회사의 개인위치정보의 수집에 대한 동의의 전부 또는 일부에 대하여 철회할 수 있습니다.</p>
            <p>② 개인위치정보주체는 회사의 개인위치정보의 수집의 일시적인 중지를 요구할 수 있습니다.</p>
            <p>③ 개인위치정보주체는 회사에 대하여 아래 자료에 대한 열람 또는 고지를 요구할 수 있고, 당해 자료 등에 오류가 있는 경우에는 그 정정을 요구할 수 있습니다.</p>
            <p>1. 개인위치정보주체에 대한 위치정보 수집/이용/제공사실 확인 자료</p>
            <p>2. 개인위치정보주체에 대한 개인위치정보가 위치정보의 보호 및 이용 등에 관한 법률 또는 다른 법률의 규정에 의하여 3자에게 제공된 이유 및 내용</p>
            <p>④ 개인위치정보주체는 본조 제1항 내지 제3항의 권리행사를 위하여 서비스 고객센터(온라인 문의)를 이용하여 회사에 요구할 수 있습니다.</p>
            <p>제17조 (개인위치정보 기반 서비스 내용)</p>
            <p>회사는 회원이 서비스를 이용할 경우 회원이 행사 영역에 들어온 시점 동안 위치정보(GPS기반정보)를 표시하는 서비스를 제공합니다.</p>
            <p>제18조 (위치정보 이용·제공사실 확인자료 보유근거 및 보유기간)</p>
            <p>회사는 위치정보의 보호 및 이용 등에 관한 법률 제 16조 2항에 근거하여 개인위치정보주체에 대한 위치정보 수집·이용·제공사실 확인자료를 위치정보시스템에 자동으로 기록하며 6개월 이상 보관합니다.</p>
            <p>제19조 (개인위치정보의 보관 및 파기)</p>
            <p>회사는 원칙적으로 개인위치정보를 개인위치정보주체가 동의한 목적 범위 내에서 이용하고 회원의 서비스 이용 관련 문의에 응대하기 위하여 해당 회원이 회원의 자격을 상실한 날로부터 3년간 보유하며 3년이 지나면 바로 파기합니다.</p>
            <p>제20조 (개인위치정보 수집 등에 관한 동의)</p>
            <p>회원과 개인위치정보주체가 다를 경우 회사는 회원으로 하여금 회사를 대신하여 개인위치정보주체로부터 개인위치정보의 수집에 대한 동의를 받아줄 것을 요청할 수 있습니다.</p>
            <p>제 9 장 손해배상</p>
            <p>제21조 (손해배상)</p>
            <p>① 회원이 본 약관의 규정을 위반함으로써 회사에 손해가 발생하게 되는 경우, 해당 회원은 회사에 발생하는 모든 손해를 배상하여야 합니다.</p>
            <p>② 회사는 회사의 과실로 인하여 회원이 손해를 입게 될 경우 본 약관 및 관련 법령에 따라 회원의 손해를 배상합니다. 다만, 회사는 회사의 과실 없이 아래 각호에 따른 손해에 대해서는 책임을 부담하지 않습니다. 또한 회사는 법률상 허용되는 한도 내에서 간접 손해, 특별 손해, 결과적 손해, 징계적 손해 및 징벌적 손해에 대한 책임을 부담하지 않습니다.</p>
            <p>1. 천재지변 또는 이에 준하는 불가항력의 상태에서 발생한 손해</p>
            <p>2. 회원의 귀책사유로 서비스 이용에 장애가 발생한 경우</p>
            <p>3. 서비스에 접속 또는 이용과정에서 발생하는 개인적인 손해</p>
            <p>4. 제3자가 불법적으로 회사의 서버에 접속하거나 서버를 이용함으로써 발생하는 손해</p>
            <p>5. 제3자가 악성 프로그램을 전송 또는 유포함으로써 발생하는 손해</p>
            <p>6. 전송된 데이터의 생략, 누락, 파괴 등으로 발생한 손해, 명예훼손 등 제3자가 서비스를 이용하는 과정에서 발생된 손해</p>
            <p>7. 기타 회사의 고의 또는 과실이 없는 사유로 인해 발생한 손해</p>
            <p>③ 회원이 서비스를 이용함에 있어 행한 불법행위나 본 약관 위반행위로 인하여 회사가 당해 회원 이외의 제3자로부터 손해배상 청구 또는 소송을 비롯한 각종 이의제기를 받는 경우 당해 회원은 자신의 책임과 비용으로 회사를 면책시켜야 하며, 회사가 면책되지 못한 경우 당해 회원은 그로 인하여 회사에 발생한 모든 손해를 배상하여야 합니다.</p>
            <p>제22조 (분쟁의 해결)</p>
            <p>① 서비스 이용과 관련하여 회사와 회원 사이에 분쟁이 발생한 경우, 회사와 회원은 분쟁의 해결을 위해 성실히 협의합니다.</p>
            <p>② 본 조 제1항의 협의에서도 분쟁이 해결되지 않을 경우 양 당사자는 민사소송법상의 관할 법원에 소를 제기할 수 있습니다.</p>
            <p>③ 회사와 회원 간에 제기된 소송에는 대한민국 법령을 적용합니다.</p>
            <p>제23조 (사업자 정보)</p>
            <p>사업자의 상호, 주소, 전화번호, 그 밖의 연락처는 다음과 같습니다.</p>
            <p>■ 상 호 : 주식회사 코엑스</p>
            <p>■ 주 소 : 서울특별시 강남구 영동대로 513 (삼성동, 코엑스)</p>
            <p>■ 대표 번호 : 02-6000-0114</p>
            <p>■ 상 호 : (주)지에스아이엘</p>
            <p>■ 주 소 : 서울특별시 서초구 청계산로 193</p>
            <p>■ 대표 번호 : 02-6247-7500</p>
            <p>부칙</p>
            <p>제1조 (시행일) 이 약관은 2023년 05월 01일부터 시행합니다.</p>
        </>
    );
}